const ArchiveList = [
  {
    name: "deku-tree",
    description: "A CLI tool to help with conventional git branch names.",
    tech: ["CLI", "NPM", "JavaScript"],
    repo: "https://github.com/andreidobrinski/deku-tree",
  },
  {
    name: "Scratchpad",
    description:
      "A notes app focused on adding new ideas. The service worker installs the app for full offline use. Intended for use as a mobile PWA.",
    tech: ["Svelte", "Tailwind", "XState", "PWA"],
    demo: "https://andreidobrinski.com/scratchpad/",
    repo: "https://github.com/andreidobrinski/scratchpad",
  },
  {
    name: "Gen Art Canvas",
    description:
      "A UI for playing around with parameters in a generative art example",
    tech: ["React", "Canvas"],
    demo: "https://andreidobrinski.com/gen-art-canvas/",
    repo: "https://github.com/andreidobrinski/gen-art-canvas",
  },
  {
    name: "Produce in Season",
    description:
      "An app to show what produce is in season this month in Ontario",
    tech: ["Svelte"],
    demo: "https://andreidobrinski.com/produce-in-season/",
    repo: "https://github.com/andreidobrinski/produce-in-season",
  },
  {
    name: "Recipes",
    description: "A cookbook filled with recipes and checklists",
    tech: ["React", "Gatsby", "MDX"],
    demo: "https://andreidobrinski.com/recipes/",
    repo: "https://github.com/andreidobrinski/recipes",
  },
  {
    name: "RL Random Camera Settings Generator",
    description: "Generate random camera settings in Rocket League",
    tech: ["React", "Gatsby"],
    demo: "https://andreidobrinski.com/rl-random-camera-settings/",
    repo: "https://github.com/andreidobrinski/rl-random-camera-settings",
  },
  {
    name: "LoadingAnimation",
    description: "A loading animation in Swift",
    tech: ["Swift", "Animation"],
    repo: "https://github.com/andreidobrinski/LoadingAnimations",
  },
];

export default ArchiveList;
